/**
 * 空态占位
 */
import type { ReactNode } from 'react';

interface EmptyProps {
  icon?: string;
  title?: string;
  desc?: string;
  action?: ReactNode;
  className?: string;
}

export default function Empty({
  icon = '🐂',
  title = '暂无数据',
  desc,
  action,
  className,
}: EmptyProps) {
  return (
    <div className={`empty ${className ?? ''}`}>
      <div className="empty-icon">{icon}</div>
      <div className="empty-title">{title}</div>
      {desc ? <div className="empty-desc">{desc}</div> : null}
      {action}
    </div>
  );
}
